import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api, authApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for get recruiter profile
export const getProfile = createAsyncThunk(
  "recruiter/profile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/recruiter/profile/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update recruiter profile
export const updateProfile = createAsyncThunk(
  "update/profile",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/recruiter/profile/update/", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for request for email changes
export const requestEmailChsanges = createAsyncThunk(
  "request/email_changes",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        "/auth/request-email-change/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for verify email changes
export const veryfyEmailChanges = createAsyncThunk(
  "verify/email_changes",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        "/auth/verify-email-change/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get bench sales profile card count
export const benchSalesProfileCardCount = createAsyncThunk(
  "count/card/profile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/req/job/requirement-tracker-count-list/?days=15`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllBranch = createAsyncThunk(
  "comapny/branch/add",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/company/company_branch/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    data: null,
    cardCountData: null,
    branchData: null,
    status: "idle",
    error: null,
  },
  reducers: {
    resetProfileStatus: (state) => {
      state.status = "idle"; // Reset the status back to "idle"
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.status = "get_profile_succeeded";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.status = "update_profile_succeeded";
        toast.success(action.payload.message);
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(requestEmailChsanges.pending, (state) => {
        state.status = "loading";
      })
      .addCase(requestEmailChsanges.fulfilled, (state, action) => {
        state.status = "request_email_changes_succeeded";
        toast.success(action.payload.message);
      })
      .addCase(requestEmailChsanges.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(veryfyEmailChanges.pending, (state) => {
        state.status = "loading";
      })
      .addCase(veryfyEmailChanges.fulfilled, (state, action) => {
        state.status = "verify_email_succeeded";
        toast.success(action.payload.message);
      })
      .addCase(veryfyEmailChanges.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(benchSalesProfileCardCount.pending, (state) => {
        state.status = "loading";
      })
      .addCase(benchSalesProfileCardCount.fulfilled, (state, action) => {
        state.status = "bench_sales_card_count_succeeded";
        state.cardCountData = action.payload;
      })
      .addCase(benchSalesProfileCardCount.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(getAllBranch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllBranch.fulfilled, (state, action) => {
        state.status = "get_all_branch_succeeded";
        state.branchData = action.payload;
      })
      .addCase(getAllBranch.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export const { resetProfileStatus } = profileSlice.actions;

export default profileSlice.reducer;
